import { Tag, Tooltip } from 'antd';
import { useContext } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  AUTO_RETURN_FLAG,
  AUTO_RETURN_TOOLTIP_TEXT,
  DELAYED_FLAG,
  DELAYED_IN_SHIPMENT_FLAG,
  DELAYED_IN_SHIPMENT_TOOLTIP_TEXT,
  DELAYED_TOOLTIP_TEXT,
  FIRST_ORDER_FLAG,
  FIRST_ORDER_TOOLTIP_TEXT,
  ORDER_TAG_TYPES,
  PRE_ORDER_FLAG,
  PRE_ORDER_TOOLTIP_TEXT,
} from '../../../../../common/constants';

// Config for each status
const STATUS_CONFIG = {
  [ORDER_TAG_TYPES.FIRST_ORDER]: {
    flag: FIRST_ORDER_FLAG,
    tooltip: FIRST_ORDER_TOOLTIP_TEXT,
  },
  [ORDER_TAG_TYPES.DELAYED_CONFIRMED]: {
    flag: DELAYED_FLAG,
    tooltip: DELAYED_TOOLTIP_TEXT,
  },
  [ORDER_TAG_TYPES.DELAYED_SHIPMENT]: {
    flag: DELAYED_IN_SHIPMENT_FLAG,
    tooltip: DELAYED_IN_SHIPMENT_TOOLTIP_TEXT,
  },
  [ORDER_TAG_TYPES.AUTO_RETURN]: {
    flag: AUTO_RETURN_FLAG,
    tooltip: AUTO_RETURN_TOOLTIP_TEXT,
    color: 'orange',
    type: 'small',
  },
  [ORDER_TAG_TYPES.PRE_ORDER]: {
    flag: PRE_ORDER_FLAG,
    tooltip: PRE_ORDER_TOOLTIP_TEXT,
    color: 'orange',
  },
};

const StatusFlag = ({ type }) => {
  const {
    state: { isDesktop },
  } = useContext(AppContext);
  const handleStop = (e) => e.stopPropagation();
  const config = STATUS_CONFIG[type];
  if (!config) return null;

  return (
    <Tooltip title={config.tooltip} placement="top" zIndex={4}>
      {!isDesktop && <span>yes</span>}
      <Tag
        color={config.color || 'red'}
        onClick={handleStop}
        className={`ml-8 mr-0 ${
          config.type === 'small' ? '' : 'express-delivery-icon'
        }`}
      >
        {config.flag}
      </Tag>
    </Tooltip>
  );
};

export default StatusFlag;
